import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import noop from 'lodash/noop';

const Checkbox = ({
  className,
  id,
  checked,
  label,
  title,
  disabled,
  onChange,
  ...rest
}) => {
  title = title || label;

  const handleChange = (event) => {
    onChange(event.target.checked);
  };

  return (
    <div className={cn('rx-checkbox', className)}>
      <input
        {...rest}
        type="checkbox"
        id={id}
        className="rx-checkbox--input"
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
      />
      <label htmlFor={id} className="rx-checkbox--label" title={title}>
        {!!label && <span>{label}</span>}
      </label>
    </div>
  );
};

Checkbox.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  checked: PropTypes.bool,
  label: PropTypes.string,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

Checkbox.defaultProps = {
  disabled: false,
  onChange: noop,
};

export default Checkbox;
